/**
 * Decode a JWT payload without verifying the signature (signature is verified
 * server-side). Returns `null` for invalid / non-JWT tokens (e.g. mock tokens).
 */
export const decodeJwt = (token) => {
  if (!token || typeof token !== "string") return null;
  const parts = token.split(".");
  if (parts.length !== 3) return null;
  try {
    const json = atob(parts[1].replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(json);
  } catch {
    return null;
  }
};

/** Returns true when the JWT has an `exp` claim that is in the past. */
export const isJwtExpired = (token) => {
  const payload = decodeJwt(token);
  if (!payload || typeof payload.exp !== "number") return false; // unknown ⇒ assume valid
  const nowSec = Math.floor(Date.now() / 1000);
  // 5 second leeway to allow for clock skew
  return payload.exp + 5 < nowSec;
};
